import dynamic from "next/dynamic";
import HubspotWithBulletsSideBySideFormConfig from "./hubspot-with-bullets-side-by-side-form-config";
import HubspotWithBulletsSideBySideFormAdvancedConfig from "./hubspot-with-bullets-side-by-side-form-advanced-config";
const HubspotWithBulletsSideBySideFormComponent = dynamic(()=>import("./hubspot-with-bullets-side-by-side-form-component"));
export default {
    HubspotWithBulletsSideBySideFormComponent,
    HubspotWithBulletsSideBySideFormConfig,
    HubspotWithBulletsSideBySideFormAdvancedConfig
};
